module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS6.81f64219.jpg";